import * as React from "react";

import type { DesignaliProps } from "../../types";

export const VercelFull = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="7.95"
        fill="currentColor"
        viewBox="0 0 24 7.95"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          d="M2.02,6.21s.01,0,.02,0c0-.01.01-.02.02-.03.84-1.46,1.69-2.92,2.53-4.37.01-.02.03-.04.04-.07.02.01.02.03.03.04.09.16.18.31.27.47.76,1.31,1.51,2.62,2.27,3.93,0,.02.02.03.02.05H2.06s-.03,0-.04,0c0,0,0,0,0,0Z"
        />
        <path
          strokeWidth={0}
          d="M21.98,5.3s-.03,0-.05,0c-.17,0-.34,0-.52,0h-.05s0-.02,0-.03c0-.01,0-.03,0-.04,0-1.03,0-2.06,0-3.09,0-.02,0-.04,0-.06.02,0,.03,0,.05,0,.17,0,.35,0,.52,0,.02,0,.03,0,.05,0v3.23Z"
        />
        <path
          strokeWidth={0}
          d="M11.37,4.35s.02.04.03.06c.08.16.21.27.37.34.14.06.29.07.44.06.09-.01.19-.03.27-.08.08-.04.14-.08.2-.14,0,0,.01-.01.02-.02,0,0,0,0,0,0,.04.02.5.28.53.31-.01.01-.02.02-.03.04-.13.14-.28.25-.45.32-.14.06-.29.1-.45.12-.11.01-.23.02-.34,0-.29-.02-.55-.11-.78-.28-.24-.18-.4-.42-.46-.72-.02-.08-.02-.16-.03-.24,0-.18.03-.36.1-.53.12-.29.33-.5.62-.63.13-.06.26-.09.4-.11.12-.02.25-.02.37,0,.23.02.45.08.64.21.27.18.44.43.51.74.03.14.04.28.03.42,0,.04-.01.08-.02.13-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0-.61,0-1.23,0-1.84,0h-.06ZM12.69,3.86s0,0,0-.01c0,0,0-.01,0-.02-.06-.16-.17-.29-.33-.36-.21-.09-.42-.09-.63,0-.17.07-.28.19-.34.36,0,0,0,.02,0,.03,0,0,.01,0,.02,0,.43,0,.86,0,1.29,0,0,0,0,0,.01,0Z"
        />
        <path
          strokeWidth={0}
          d="M20.27,4.56c.18.11.36.21.54.31,0,.02-.01.03-.02.03-.11.12-.24.22-.39.3-.17.08-.34.14-.53.16-.26.03-.51,0-.76-.08-.18-.06-.34-.16-.47-.29-.19-.18-.31-.41-.36-.67-.04-.23-.02-.45.06-.67.12-.32.33-.54.64-.68.13-.06.26-.09.4-.11.12-.02.25-.02.37,0,.23.02.45.09.64.21.27.18.44.42.51.73.03.15.04.29.03.44,0,.04-.01.07-.02.11-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0-.61,0-1.23,0-1.84,0-.02,0-.04,0-.05,0,0,.02,0,.03.02.05.06.12.14.21.26.28.11.07.22.1.35.12.13.02.26,0,.39-.04.11-.04.21-.1.3-.18,0,0,0-.01.02-.02ZM20.26,3.86s0-.01,0-.02c0,0,0-.01,0-.02-.07-.17-.18-.3-.35-.36-.2-.08-.4-.08-.6,0-.17.07-.29.2-.35.37,0,0,0,.02,0,.03.01,0,.02,0,.03,0,.43,0,.86,0,1.29,0Z"
        />
        <path
          strokeWidth={0}
          d="M9.25,5.43c-.65-1.12-1.29-2.23-1.94-3.35.01,0,.02,0,.02,0,.03,0,.05,0,.08,0,.19,0,.38,0,.57,0,.02,0,.03,0,.05,0,.4.7.81,1.4,1.21,2.09.02,0,.02-.01.03-.02.07-.12.14-.24.21-.36.32-.55.64-1.11.96-1.66,0-.02.02-.03.03-.04,0,0,0,0,0,0,0,0,0,0,0,0,.23,0,.45,0,.68,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.64,1.11-1.29,2.22-1.93,3.34,0,0,0,0,0,0,0,0,0,0,0,0Z"
        />
        <path
          strokeWidth={0}
          d="M18.05,3.44s-.51.3-.54.31c0,0,0-.01-.01-.02-.09-.16-.23-.25-.4-.3-.16-.04-.31-.04-.47.01-.21.07-.35.21-.41.42-.05.15-.05.31,0,.47.07.25.24.4.49.45.15.03.3.03.45-.02.14-.05.26-.14.34-.27,0-.01.01-.02.02-.03.03.01.49.28.54.31,0,.02-.01.03-.02.04-.12.18-.27.31-.46.4-.15.07-.3.12-.46.14-.12.01-.23.02-.35,0-.23-.02-.44-.08-.63-.2-.26-.16-.43-.39-.51-.68-.07-.26-.07-.52,0-.77.1-.34.32-.59.64-.74.13-.06.28-.1.42-.12.12-.02.24-.02.36,0,.27.02.52.11.74.28.1.08.18.17.25.27,0,.01.01.02.02.04Z"
        />
        <path
          strokeWidth={0}
          d="M13.79,2.92c.06,0,.59,0,.62,0,0,.01,0,.03,0,.05,0,.15,0,.3,0,.45,0,.02,0,.03,0,.06,0,0,0-.01,0-.01.03-.11.09-.21.18-.29.09-.09.2-.15.32-.19.12-.04.24-.06.37-.07.01,0,.03,0,.04,0,0,.01,0,.02,0,.03,0,.19,0,.6,0,.64-.02,0-.03,0-.04,0-.14-.03-.28-.03-.42.01-.24.08-.38.24-.44.48-.02.07-.02.13-.02.2,0,.32,0,.65,0,.97,0,.02,0,.04,0,.05-.05,0-.1,0-.16,0-.05,0-.1,0-.16,0s-.1,0-.15,0c-.05,0-.1,0-.15,0,0,0,0,0,0-.01,0-.78,0-1.57,0-2.35,0,0,0-.01,0-.02Z"
        />
      </svg>
    );
  },
);

export default VercelFull;
